export const numberReplace = (number) => {
    return number.replaceAll(" ", "")
}